<div [dir]="direction"
     [style.--auth-background-image]="authBackgroundImage">
  <router-outlet></router-outlet>
</div>
